import {click_event} from './analysis'
import {ACT_NOT_INIT, ACT_NOT_BEGIN, ACT_RUNNING, ACT_END} from '../../constant/act_stat'
import {login} from './login'
import to_casher from './casher'
import {isFunction, isString} from '../typeof'
import {toInt} from '../toInt'


let enable_click = true;

export default function click_handler(event_name, cb, {
  need_login = false,
  need_act = true,
  need_vip_level = -1,
  need_new_user = false
} = {
  need_login: false,
  need_act: true,
  need_vip_level: -1,
  need_new_user: false
}) {


  if (!enable_click) {
    console.error('点击过快！');
    return false;
  }
  enable_click = false;
  setTimeout(() => {
    enable_click = true
  }, 500);

  console.log(event_name)
  if (!isString(event_name)) {
    throw new Error('click_handler:event_name should be string')
  }
  click_event(event_name + "(点击)");

  need_vip_level = toInt(need_vip_level);

  //判断活动是否开始
  if (need_act) {
    if (window.$bus.act.act_stat === ACT_NOT_INIT) {
      window.$toast("在获取活动状态，请稍后...");
      return false;
    }
    else if (window.$bus.act.act_stat === ACT_NOT_BEGIN) {
      window.$toast("活动未开始，敬请期待");

      return false;
    }
    else if (window.$bus.act.act_stat === ACT_END) {
      window.$toast("活动已结束");
      return false;
    }
  }

  //判断是否登陆
  if (!window.$bus.user.uuid && (need_vip_level >= 0 || need_login || need_new_user)) {
    login();
    return false;
  }

  //判断是否是新用户
  if (need_new_user && window.$bus.user.user_type !== 1) {
    window.$toast('仅限新用户参与哦~');
    return false;
  }

  //判断会员等级
  if (need_vip_level >= 0) {
    if (window.$bus.user.vip_id === 0) {     //非会员
      window.$act_alert_dialog.show({
        title: `<div style="text-align: center">您还不是会员，仅限会员参与哦~</div>`,
        button: "立刻开通"
      }).then(res => {
        to_casher()
      }).catch(res => {
      });
      return false;
    } else if (need_vip_level > window.$bus.user.level) { //会员等级不满足条件
      window.$act_alert_dialog.show({
        title: `<div style="text-align: center">您的会员等级不足，需要${need_vip_level}级会员才可参与哦~</div>`,
        button: "立即续费"
      }).then(res => {
        to_casher()
      }).catch(res => {
      });
      return false;
    }
  }

  if (!isFunction(cb)) {
    console.error('click_handler:cb should be function');
    return false;
  }

  click_event(event_name + "(生效)");
  setTimeout(cb, 0);
  return true
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/click.js